import EmployeeModel from "./EmployeeModel";

export default class UserModel {
    constructor(data?: any) {
        if (data) {
            this.id = data.id ?? 0;
            this.date = data.date ?? new Date(1970,0,1);            
            
            this.login = data.login;
            this.password = data.password;
            this.lastLoginDate = data.date;
            this.blocked = data.blocked;
            this.blockReason = data.blockReason;
            
            if (data.employee) {
                this.employee = data.employee;
            }
            
            if (data.roles) {
                this.roles = data.roles;
            }
        }
    }

    id = 0;
    date = new Date(1970,0,1);
    login = '';
    password: string | null = null;
    lastLoginDate: Date | null = null;
    blocked = false;
    blockReason: string | null = null;
    employee: EmployeeModel | null = null;
    roles: Array<any> | null = null;
}